import { CreateConcertRequest, CreateConcertResponse, Concert } from '@/types/model';
import { apiClient, QueryParams, PaginatedResponse } from './apiClient';

export interface ConcertQueryParams extends QueryParams {
  active?: boolean;
  categoryId?: string;
  year?: number;
  kidsContent?: boolean;
}

export const concertService = {
  /**
   * Get concerts with pagination, search, and filtering
   */
  async getConcerts(params: ConcertQueryParams = {}): Promise<PaginatedResponse<Concert>> {
    return apiClient.getPaginated<Concert>('/concerts', params);
  },

  /**
   * Get a single concert by ID
   */
  async getConcertById(id: string): Promise<Concert> {
    return apiClient.getById<Concert>('/concerts', id);
  },

  /**
   * Create a new concert
   */
  async createConcert(concertData: CreateConcertRequest): Promise<CreateConcertResponse> {
    return apiClient.create<CreateConcertRequest, CreateConcertResponse>('/concerts', concertData);
  },

  /**
   * Update a concert
   */
  async updateConcert(id: string, concertData: Partial<CreateConcertRequest>): Promise<CreateConcertResponse> {
    return apiClient.update<Partial<CreateConcertRequest>, CreateConcertResponse>('/concerts', id, concertData);
  },

  /**
   * Delete a concert
   */
  async deleteConcert(id: string): Promise<{ success: boolean; message: string }> {
    return apiClient.deleteById<{ success: boolean; message: string }>('/concerts', id);
  },

  /**
   * Toggle concert active status
   */
  async toggleConcertStatus(id: string, active: boolean): Promise<CreateConcertResponse> {
    return apiClient.toggleStatus<CreateConcertResponse>('/concerts', id, active);
  },
};